"use client";

import classNames from "classnames";
import { getWatchProgressPercent } from "@/utils/watchTrackerService";

const EpisodeProgressIndicator = ({ progress, compact = false, className }) => {
  const percent = getWatchProgressPercent(progress);

  if (percent <= 0) return null;

  return (
    <div
      className={classNames(
        "absolute z-20 overflow-hidden rounded-full bg-[#5B5B5B] shadow-[0_1px_3px_rgba(0,0,0,0.55)]",
        compact ? "inset-x-1.5 bottom-1.5 h-1" : "inset-x-2.5 bottom-2.5 h-1.5",
        className
      )}
      dir="ltr"
      role="progressbar"
      aria-label="پیشرفت تماشای قسمت"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(percent)}
    >
      <div
        className="h-full rounded-full bg-[#E50914]"
        style={{ width: `${percent}%` }}
      />
    </div>
  );
};

export default EpisodeProgressIndicator;
